import { IKnmEvent248Protocol } from 'APIPackage/KnmModule/interfaces/IKnmEvent248Protocol';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';

import { convertActEventDocumentsFormValueToKnmData } from './convertActEventDocumentsFormValueToKnmData';
import { IKnmErknmFormEventProtocol } from '../interfaces/IKnmErknmFormEventProtocol';
import { convertActEventStudiedDocumentsFormValueToKnmData } from './convertActEventStudiedDocumentsFormValueToKnmData';

export const convertEventsProtocolsFormValuesToKnmData = (
  protocol: IKnmErknmFormEventProtocol | undefined,
): IKnmEvent248Protocol | undefined => {
  if (!protocol) {
    return undefined;
  }

  const protocolResult: IKnmEvent248Protocol = {
    guid: protocol.guid,
    appendicesToTheProtocolOfAction: convertActEventDocumentsFormValueToKnmData(
      protocol.appendicesToTheProtocolOfAction,
    ),
    studiedDocuments: convertActEventStudiedDocumentsFormValueToKnmData(protocol.studiedDocuments),
    file: {
      active: protocol.file?.active || null,
      attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(protocol.file?.attachments),
      correlationToken: protocol.file?.correlationToken || null,
      description: protocol.file?.description || null,
      guid: protocol.file?.guid || null,
      type: protocol.file?.type ? deleteObjectProperties(protocol.file.type, ['label', 'value']) : null,
    },
  };

  return protocolResult;
};
